import { z } from "zod";

export const PluginBuiltBySchema_2024_05_05 = z.object({
  builtBy: z.string().nullish(),
  updateReason: z.string().nullish(),
});
export type PluginBuiltByType_2024_05_05 = z.infer<
  typeof PluginBuiltBySchema_2024_05_05
>;
